export const SET_LOADING = 'SET_LOADING';
export const SET_STORIES = 'SET_STORIES';
export const REMOVE_STORY = 'REMOVE_STORY';
export const HANDLE_PAGE = 'HANDLE_PAGE';
export const HANDLE_SEARCH = 'HANDLE_SEARCH';
